<button (click)="login()">
  <mat-icon>lock_outline</mat-icon> Login
</button>
